import { PartnerProfileStatuses } from '@trnsact/trnsact-shared-types';

export const colorsByStatus: Record<PartnerProfileStatuses, Record<'color' | 'bgColor', string>> = {
  [PartnerProfileStatuses.Active]: {
    color: '#33691E',
    bgColor: '#DCEDC8',
  },
  [PartnerProfileStatuses.Onboarding]: {
    color: '#0057B2',
    bgColor: '#BBDEFB',
  },
  [PartnerProfileStatuses.Staged]: {
    color: '#424242',
    bgColor: '#EEEEEE',
  },
};
